import "./ActivitiesCardsCarousel.scss";
import "react-alice-carousel/lib/scss/alice-carousel.scss";
import card_bg from "../../Assets/Tutor/card_bg.png";
import { useEffect, useState } from "react";
import { axiosInstance } from "../../Utilities/Interceptor/Interceptor";
import { API_END_POINTS, AUTHENTICATION, GLOBAL_CONSTANTS, ROUTES } from "../../Constants/Constants";
import { useNavigate } from "react-router-dom";
import campIcon from "../../Assets/Activities/camp_icon.svg";
import ptIcon from "../../Assets/Activities/cap.svg";
import WebShareComponent from "../WebShare/WebShare";
import toast from "react-hot-toast";
import React from "react";
import type { FC } from "react";
import { setLoginSignUpOpen } from "../../Redux/Reducer/Reducer";
import { GetSessionStorageData, encryptPassData, nullUndefinedEmptyCheck } from "../../Utilities/Helpers/Helper";
import { useDispatch, useSelector } from "react-redux";
import shareIcon from "../../Assets/Activities/share_activity.svg";
import LikeIcon from "../../Assets/Activities/like_activity.svg";
import ActivityFill from "../../Assets/HeartFill/ActivityFill.svg";
import locationIcon from "../../Assets/Tutor/location.svg";
import moment from "moment";
import calendar_ac from "../../Assets/Activities/calendar_ac.svg";
import { Rating } from "@mui/material";
import { Tab, Tabs, Typography } from "@mui/material";
import Box from '@mui/material/Box';
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

function TabPanel(props: any) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index: any) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

interface Props {
  radius?: number;
  lat?: number | string;
  lng?: number | string;
  lang?: number | string;
  ActivityList?: any;
  ActivityApiCall?: () => void;
}

const ActivitiesCardsCarousel: FC<Props> = ({ radius, lat, lng, lang, ActivityList = { camp: [], personal: [] }, ActivityApiCall }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [popularList, setPopularList] = useState<{ camp: any[]; personal: any[] }>({ camp: [], personal: [] });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [Tapvalue, setTapValue] = useState(0);
  const { t } = useTranslation();
  const language = useSelector((state: any) => state.languageReducer.language);
  const [searchText, setSearchText] = useState(""); 

  const isItemAvailableInNextNDays = (item: any, n = 90): boolean => {
    if (!item) return false;
    const now = moment().startOf("day");
    const future = moment().add(n, "days").endOf("day");

    const ranges = [];
    if (item?.start_date || item?.end_date) {
      ranges.push({ start: item?.start_date || null, end: item?.end_date || null });
    }
    if (Array.isArray(item?.trainer_activity) && item.trainer_activity.length > 0) {
      item.trainer_activity.forEach((ta: any) => {
        if (ta?.start_date || ta?.end_date) {
          ranges.push({ start: ta?.start_date || null, end: ta?.end_date || null });
        }
        if (ta?.session_start_date || ta?.session_end_date) {
          ranges.push({ start: ta?.session_start_date || null, end: ta?.session_end_date || null });
        }
      });
    }
    if (ranges.length === 0) return true;
    return ranges.some((r) => {
      const s = r.start ? moment(r.start) : null;
      const e = r.end ? moment(r.end) : null;
      const start = s || now;
      const end = e || future;
      return start.isSameOrBefore(future) && end.isSameOrAfter(now);
    });
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTapValue(newValue);
  };

  const getPopular_TutorList = () => {
    const longitude = lang ?? lng;
    
    const params: any = {
      latitude: lat ? String(lat) : undefined,
      longitude: longitude ? String(longitude) : undefined,
      radius: 30, 
      search: searchText ? encodeURIComponent(searchText) : undefined
    };

    const sanitizedParams = Object.fromEntries(
      Object.entries(params).filter(([_, v]) => v != null)
    );

    axiosInstance
      .get(`${API_END_POINTS.POPULAR_ACTIVITIES_LIST}`, {
        params: sanitizedParams,
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        if (response?.data?.status) {
          setPopularList(response?.data?.result?.data || { camp: [], personal: [] });
          setActiveIndex(0);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        toast.error(t("Failed to fetch activities"));
      });
  };

  useEffect(() => {
    if (!ActivityList?.personal?.length || !ActivityList?.camp?.length) {
      getPopular_TutorList();
    }
  }, [ActivityList, lat, lng, lang, radius, searchText]);

  const navigateActiviesDetailedView = (ActiviesDetailes: any) => {
    navigate(
      ROUTES.ACTIVITY_DETAILE_VIEW +
        "?id=" +
        encryptPassData(ActiviesDetailes?.id) +
        "&type=" +
        encryptPassData(ActiviesDetailes?.is_service_type),
      { state: { Activies_Detailes: ActiviesDetailes } }
    );
  };

  const navigateActivityListView = () => {
    navigate(ROUTES.ACTIVITY_LIST_VIEW, {
      state: {
        activities_list: "",
        search_text: searchText,
        radius: radius,
        lat: lat,
        lng: lng,
      },
    });
  };

  const handleChangeFavourites = (val: boolean, id: any, is_service_type: string, campId?: any) => {
    const accessToken = GetSessionStorageData(AUTHENTICATION.SHARED.ACCESS_TOKEN);
    if (nullUndefinedEmptyCheck(accessToken)) {
      const payload =
        is_service_type === "camp"
          ? {
              service_provider_type: GLOBAL_CONSTANTS.INITIAL_VALUES.THREE_INT,
              service_provider: id,
              is_favourite: !val,
              camp_session: campId,
            }
          : {
              service_provider_type: GLOBAL_CONSTANTS.INITIAL_VALUES.TWO_INT,
              service_provider: id,
              is_favourite: !val,
            };
      axiosInstance
        .post(`${API_END_POINTS.FAVOURITE__ADD}`, payload)
        .then((response) => {
          if (response?.data?.status) {
            if (typeof ActivityApiCall === "function") {
              ActivityApiCall();
            }
            toast.success(response?.data?.message, {
              position: GLOBAL_CONSTANTS.INITIAL_VALUES.TOAST_POSITION,
            });
          }
        })
        .catch((error) => {
          console.error("Favourite API Error:", error);
          toast.error(t("Failed to update favourites"));
        });
    } else {
      dispatch(setLoginSignUpOpen(GLOBAL_CONSTANTS.INITIAL_VALUES.TRUE));
    }
  };
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
  };

  const viewList = popularList?.personal?.map((item: any, i: number) => {
    return (
      <div
        className="Activies_card_carousel_wrapper"
        key={i}
        onClick={() => navigateActiviesDetailedView(item)}
      >
        <div className="Activies_card_wrapper">
          <img src={ptIcon} alt="" className="cornorIcon" />
          <img
            className="card_bg_img"
            src={item?.profile_image ? item.profile_image : card_bg}
            alt="Trainer"
            onError={(e) => {
              (e.target as HTMLImageElement).src = card_bg;
            }}
          />
          <div className="Activies_card_text notranslate" dir="rtl">
            {language === "English"
              ? `${item.profile_details?.firstname || ""} ${item.profile_details?.lastname || ""}`.trim()
              : `${item.profile_details?.arabic_firstname || item.profile_details?.firstname || ""} ${
                  item.profile_details?.arabic_lastname || item.profile_details?.lastname || ""
                }`.trim()}
          </div>
        </div>
      </div>
    );
  });

  const CampList = popularList?.camp?.map((item: any, i: number) => {
    return (
      <div
        className="Activies_card_carousel_wrapper"
        key={i}
        onClick={() => navigateActiviesDetailedView(item)}
      >
        <div className="Activies_card_wrapper">
          <img src={campIcon} alt="" className="cornorIcon" />
          <img
            className="card_bg_img"
            src={item?.camp_images?.length > 0 ? item?.camp_images[0] : card_bg}
            alt="Learn and Play"
            onError={(e) => {
              (e.target as HTMLImageElement).src = card_bg;
            }}
          />
          <div className="Activies_card_text">
            {language === "English" ? item?.camp_session_title : item?.arabic_camp_session_title || item?.camp_session_title}
          </div>
        </div>
      </div>
    );
  });

  if (popularList?.camp?.length > 10) {
    CampList?.push(
      <div
        className="activity_card_carousel_exploreAll__wapper"
        onClick={() => navigateActivityListView()}
      >
        <div className="text">Explore all</div>
        <div className="title">Camps</div>
      </div>
    );
  }

  if (popularList?.personal?.length > 10) {
    viewList?.push(
      <div
        className="activity_card_carousel_exploreAll__wapper"
        onClick={() => navigateActivityListView()}
      >
        <div className="text">Explore all</div>
        <div className="title">Personal Trainer</div>
      </div>
    );
  }

  return (
    <>


      <div className="d-none d-xl-block">
        <div className="row">
          <div className="col-md-6 col-sm-12">
            <div className="Activies_carousel_title">{t("Find sports Camps near you")}</div>
            <div className="activities__listView__container mt-3">
              {ActivityList?.camp?.slice(0, 5)?.map((item: any, i: number) => {
                const itemAvailable = isItemAvailableInNextNDays(item, 90);
                const today = new Date();
                today.setHours(0, 0, 0, 0);

                return (
                  <div
                    className="activities__list__wapper"
                    key={i}
                    onClick={() => navigateActiviesDetailedView(item)}
                  >
                    <div className="activities__leftside">
                      <img src={campIcon} alt="" className="identity_icon" />
                      <img
                        className="profile_img"
                        src={item?.camp_images?.length > 0 ? item?.camp_images[0] : card_bg}
                        alt="activitiesImg"
                        onError={(e) => {
                          (e.target as HTMLImageElement).src = card_bg;
                        }}
                      />
                    </div>
                    <div className="activities__rightside">
                      <div className="activity_top">
                        <div className="activities__name">
                          <div className="age_group_wapper">
                            <span className="name d-block d-lg-none notranslate">
                              {(language === "English" ? item?.camp_session_title : item?.arabic_camp_session_title || item?.camp_session_title)?.substring(0, 12) + "..."}
                            </span>
                            <span className="name d-none d-md-block notranslate">
                              {language === "English" ? item?.camp_session_title : item?.arabic_camp_session_title || item?.camp_session_title}
                            </span>
                            <span className="age_group_badge">{t("under")} {item?.max_age}</span>
                          </div>
                          <div className="imageIcon" onClick={(e) => e.stopPropagation()}>
                            <WebShareComponent
                              params={
                                ROUTES.ACTIVITY_DETAILE_VIEW +
                                "?id=" +
                                encryptPassData(item?.id) +
                                "&type=" +
                                encryptPassData(item?.is_service_type)
                              }
                            >
                              <img src={shareIcon} alt="" className="mb-1" />
                            </WebShareComponent>
                            {item?.is_favourite ? (
                              <img
                                src={ActivityFill}
                                alt=""
                                onClick={() => handleChangeFavourites(item.is_favourite, item?.user, item?.is_service_type, item?.id)}
                              />
                            ) : (
                              <img
                                src={LikeIcon}
                                alt=""
                                onClick={() => handleChangeFavourites(item.is_favourite, item?.user, item?.is_service_type, item?.id)}
                              />
                            )}
                          </div>
                        </div>
                        <div className="camp_dates notranslate" style={{ display: language === "English" ? "contents" : "flex" }}>
                          By - {language === "English" ? `${item.camp_name || ""}`.trim() : `${item.arabic_camp_name || item.camp_name}`.trim()}
                        </div>
                        <div className="activities__location">
                          <img src={locationIcon} alt="" />
                          <span className="location" title={item?.city}>{item?.city}</span>
                        </div>
                        <div className="activities__camp_dates">
                          <img src={calendar_ac} alt="" className="camp_dates__icon" />
                          <div className="camp_dates">
                            {moment(new Date(item?.start_date)).format("MMM DD")} -{" "}
                            {moment(new Date(item?.end_date)).format("MMM DD")}
                          </div>
                        </div>
                      </div>
                      <div className="activities__rating">
                        <div className="total_class_wapper">
                          <div className="text__contant">{t("AED")} {item?.total_class_fee}</div>
                          <div className="total_class_text">
                            {t("for")} {item?.total_class} {t("classes")}
                          </div>
                        </div>
                        <div className="d-flex flex-row">
                          <Rating name="half-rating-read" className="StarIcon" value={parseInt(item?.rating)} readOnly />
                          <span className="points ms-2">{item?.rating}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
              {ActivityList?.camp?.length === 0 && (
                <div className="No__data__contant">
                  <div className="text">{t("No Data Found")}</div>
                </div>
              )}
            </div>
          </div>
          <div className="p-0 col-md-6 col-sm-12 find-sport-personal-wrap">
            <div className="Activies_carousel_title">{t("Find sports Personal Trainer near you")}</div>
            <div className="activities__listView__container">
              {ActivityList?.personal?.slice(0, 5)?.map((item: any, i: number) => {
                const itemAvailable = isItemAvailableInNextNDays(item, 90);
                return (
                  <div
                    className="activities__list__wapper"
                    key={i}
                    onClick={() => navigateActiviesDetailedView(item)}
                  >
                    <div className="activities__leftside">
                      <img src={ptIcon} alt="" className="identity_icon" />
                      <img
                        className="profile_img"
                        src={item?.profile_image ? item.profile_image : card_bg}
                        alt="trainerImg"
                        onError={(e) => {
                          (e.target as HTMLImageElement).src = card_bg;
                        }}
                      />
                    </div>
                    <div className="activities__rightside">
                      <div className="activity_top">
                        <div className="activities__name">
                          <span className="name d-block d-lg-none notranslate">
                            {item?.type_camp
                              ? language === "English"
                                ? `${item?.campname?.substring(0, 12) + "..." || ""}`
                                : `${item?.arabic_campname?.substring(0, 12) + "..." || ""}`
                              : language === "English"
                              ? `${(item?.profile_details?.firstname || "") + " " + (item?.profile_details?.lastname || "")}`.substring(0, 12) + "..."
                              : `${(item?.profile_details?.arabic_firstname || item?.profile_details?.firstname || "") + " " + (item?.profile_details?.arabic_lastname || item?.profile_details?.lastname || "")}`.substring(0, 12) + "..."}
                          </span>
                          <span className="name d-none d-md-block notranslate">
                            {item?.type_camp
                              ? language === "English"
                                ? `${item?.campname || ""}`
                                : `${item?.arabic_campname || ""}`
                              : language === "English"
                              ? `${(item?.profile_details?.firstname || "") + " " + (item?.profile_details?.lastname || "")}`.trim()
                              : `${(item?.profile_details?.arabic_firstname || item?.profile_details?.firstname || "") + " " + (item?.profile_details?.arabic_lastname || item?.profile_details?.lastname || "")}`.trim()}
                          </span>
                          <div className="imageIcon" onClick={(e) => e.stopPropagation()}>
                            <WebShareComponent
                              params={
                                ROUTES.ACTIVITY_DETAILE_VIEW +
                                "?id=" +
                                encryptPassData(item?.id) +
                                "&type=" +
                                encryptPassData(item?.is_service_type)
                              }
                            >
                              <img src={shareIcon} alt="" className="mb-1" />
                            </WebShareComponent>
                            {item?.is_favourite ? (
                              <img
                                src={ActivityFill}
                                alt=""
                                onClick={() => handleChangeFavourites(item.is_favourite, item?.user, item?.is_service_type, item?.id)}
                              />
                            ) : (
                              <img
                                src={LikeIcon}
                                alt=""
                                onClick={() => handleChangeFavourites(item.is_favourite, item?.user, item?.is_service_type, item?.id)}
                              />
                            )}
                          </div>
                        </div>
                        <div className="activities__location">
                          <img src={locationIcon} alt="" />
                          <span className="location" title={item?.city}>{item?.city}</span>
                        </div>
                        <div className="Slots_activities">
                          <div className="lable">
                            <img
                              src={item?.trainer_activity?.length > 0 ? item?.trainer_activity[0]?.category_icon : ""}
                              alt=""
                            />
                            {item?.trainer_activity?.length > 0 ? item?.trainer_activity[0]?.activites : ""}
                          </div>
                        </div>
                      </div>
                      <div className="activities__rating">
                        <div className="text__contant">
                          {t("AED")} {item?.trainer_activity?.length > 0 ? item?.trainer_activity[0]?.expected_fee : "N/A"}
                        </div>
                        <div className="d-flex flex-row">
                          <Rating
                            name="half-rating-read"
                            className="StarIcon"
                            value={parseInt(item?.rating) || 0}
                            readOnly
                          />
                          <span className="points ms-2">{item?.rating || "0"}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
              {ActivityList?.personal?.length === 0 && (
                <div className="No__data__contant">
                  <div className="text">{t("No Data Found")}</div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="row d-lg-block d-xl-none">
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            marginTop: "2rem",
          }}
        >
          <Tabs
            className="Activities__Taps"
            value={Tapvalue}
            centered
            onChange={handleChange}
            aria-label="basic tabs example"
            textColor="secondary"
            indicatorColor="secondary"
          >
            <Tab label={t("Camps")} {...a11yProps(0)} />
            <Tab label={t("Personal Trainers")} {...a11yProps(1)} />
          </Tabs>
        </Box>
        <div className="activities__listView__container">
          <TabPanel value={Tapvalue} index={0}>
            {ActivityList?.camp?.slice(0, 5)?.map((item: any, i: number) => {
              const itemAvailable = isItemAvailableInNextNDays(item, 90);
              const today = new Date();
              today.setHours(0, 0, 0, 0);

              return (
                <div
                  className="activities__list__wapper"
                  key={i}
                  onClick={() => navigateActiviesDetailedView(item)}
                >
                  <div className="activities__leftside">
                    <img src={campIcon} alt="" className="identity_icon" />
                    <img
                      className="profile_img"
                      src={item?.camp_images?.length > 0 ? item?.camp_images[0] : card_bg}
                      alt="activitiesImg"
                      onError={(e) => {
                        (e.target as HTMLImageElement).src = card_bg;
                      }}
                    />
                  </div>
                  <div className="activities__rightside">
                    <div className="activity_top">
                      <div className="activities__name">
                        <div className="age_group_wapper">
                          <span className="name d-block d-lg-none notranslate">
                            {(language === "English" ? item?.camp_session_title : item?.arabic_camp_session_title || item?.camp_session_title)?.substring(0, 12) + "..."}
                          </span>
                          <span className="name d-none d-md-block notranslate">
                            {language === "English" ? item?.camp_session_title : item?.arabic_camp_session_title || item?.camp_session_title}
                          </span>
                          <span className="age_group_badge">{t("under")} {item?.max_age}</span>
                        </div>
                        <div className="imageIcon" onClick={(e) => e.stopPropagation()}>
                          <WebShareComponent
                            params={
                              ROUTES.ACTIVITY_DETAILE_VIEW +
                              "?id=" +
                              encryptPassData(item?.id) +
                              "&type=" +
                              encryptPassData(item?.is_service_type)
                            }
                          >
                            <img src={shareIcon} alt="" className="mb-1" />
                          </WebShareComponent>
                          {item?.is_favourite ? (
                            <img
                              src={ActivityFill}
                              alt=""
                              onClick={() => handleChangeFavourites(item.is_favourite, item?.user, item?.is_service_type, item?.id)}
                            />
                          ) : (
                            <img
                              src={LikeIcon}
                              alt=""
                              onClick={() => handleChangeFavourites(item.is_favourite, item?.user, item?.is_service_type, item?.id)}
                            />
                          )}
                        </div>
                      </div>
                      <div className="camp_dates notranslate" style={{ display: language === "English" ? "contents" : "flex" }}>
                        By {language === "English" ? `${item.camp_name || ""}`.trim() : `${item.arabic_camp_name || item.camp_name}`.trim()}
                      </div>
                      <div className="activities__location">
                        <img src={locationIcon} alt="" />
                        <span className="location" title={item?.city}>{item?.city}</span>
                      </div>
                      <div className="activities__location">
                        <img src={calendar_ac} alt="" />
                        <span className="location" title={item?.city}>
                          {moment(new Date(item?.start_date)).format("MMM DD")} -{" "}
                          {moment(new Date(item?.end_date)).format("MMM DD")}
                        </span>
                      </div>
                    </div>
                    <div className="activities__rating">
                      <div className="total_class_wapper">
                        <div className="text__contant">{t("AED")} {item?.total_class_fee}</div>
                        <div className="total_class_text">
                          {t("for")} {item?.total_class} {t("classes")}
                        </div>
                      </div>
                      <div className="d-flex flex-row">
                        <Rating
                          name="half-rating-read"
                          className="StarIcon"
                          value={parseInt(item?.rating) || 0}
                          readOnly
                        />
                        <span className="points ms-2">{item?.rating || "0"}</span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
            {ActivityList?.camp?.length === 0 && (
              <div className="No__data__contant">
                <div className="text">{t("No Data Found")}</div>
              </div>
            )}
          </TabPanel>
          <TabPanel value={Tapvalue} index={1}>
            {ActivityList?.personal?.map((item: any, i: number) => {
              const itemAvailable = isItemAvailableInNextNDays(item, 90);
              return (
                <div
                  className="activities__list__wapper"
                  key={i}
                  onClick={() => navigateActiviesDetailedView(item)}
                >
                  <div className="activities__leftside">
                    <img src={ptIcon} alt="" className="identity_icon" />
                    <img
                      className="profile_img"
                      src={item?.profile_image ? item.profile_image : card_bg}
                      alt="activitiesImg"
                      onError={(e) => {
                        (e.target as HTMLImageElement).src = card_bg;
                      }}
                    />
                  </div>
                  <div className="activities__rightside">
                    <div className="activity_top">
                      <div className="activities__name">
                        <span className="name d-block d-lg-none notranslate">
                          {item?.type_camp
                            ? language === "English"
                              ? `${item?.campname?.substring(0, 12) + "..." || ""}`
                              : `${item?.arabic_campname?.substring(0, 12) + "..." || ""}`
                            : language === "English"
                            ? `${(item?.profile_details?.firstname || "") + " " + (item?.profile_details?.lastname || "")}`.substring(0, 12) + "..."
                            : `${(item?.profile_details?.arabic_firstname || item?.profile_details?.firstname || "") + " " + (item?.profile_details?.arabic_lastname || item?.profile_details?.lastname || "")}`.substring(0, 12) + "..."}
                        </span>
                        <span className="name d-none d-md-block notranslate">
                          {item?.type_camp
                            ? language === "English"
                              ? `${item?.campname || ""}`
                              : `${item?.arabic_campname || ""}`
                            : language === "English"
                            ? `${(item?.profile_details?.firstname || "") + " " + (item?.profile_details?.lastname || "")}`.trim()
                            : `${(item?.profile_details?.arabic_firstname || item?.profile_details?.firstname || "") + " " + (item?.profile_details?.arabic_lastname || item?.profile_details?.lastname || "")}`.trim()}
                        </span>
                        <div className="imageIcon" onClick={(e) => e.stopPropagation()}>
                          <WebShareComponent
                            params={
                              ROUTES.ACTIVITY_DETAILE_VIEW +
                              "?id=" +
                              encryptPassData(item?.id) +
                              "&type=" +
                              encryptPassData(item?.is_service_type)
                            }
                          >
                            <img src={shareIcon} alt="" className="mb-1" />
                          </WebShareComponent>
                          {item?.is_favourite ? (
                            <img
                              src={ActivityFill}
                              alt=""
                              onClick={() => handleChangeFavourites(item.is_favourite, item?.user, item?.is_service_type, item?.id)}
                            />
                          ) : (
                            <img
                              src={LikeIcon}
                              alt=""
                              onClick={() => handleChangeFavourites(item.is_favourite, item?.user, item?.is_service_type, item?.id)}
                            />
                          )}
                        </div>
                      </div>
                      <div className="activities__location">
                        <img src={locationIcon} alt="" />
                        <span className="location" title={item?.city}>{item?.city}</span>
                      </div>
                      <div className="Slots_activities">
                        <div className="lable">
                          <img
                            src={item?.trainer_activity?.length > 0 ? item?.trainer_activity[0]?.category_icon : ""}
                            alt=""
                          />
                          {item?.trainer_activity?.length > 0 ? item?.trainer_activity[0]?.activites : ""}
                        </div>
                      </div>
                    </div>
                    <div className="activities__rating">
                      <div className="text__contant">
                        {t("AED")} {item?.trainer_activity?.length > 0 ? item?.trainer_activity[0]?.expected_fee : "N/A"}
                      </div>
                      <div className="d-flex flex-row">
                        <Rating
                          name="half-rating-read"
                          className="StarIcon"
                          value={parseInt(item?.rating) || 0}
                          readOnly
                        />
                        <span className="points ms-2">{item?.rating || "0"}</span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
            {ActivityList?.personal?.length === 0 && (
              <div className="No__data__contant">
                <div className="text">{t("No Data Found")}</div>
              </div>
            )}
          </TabPanel>
        </div>
      </div>
    </>
  );
};

export default ActivitiesCardsCarousel;